import { isBefore } from 'date-fns';

export const onlyNums = (value: string | undefined) =>
  value ? value.toString().replace(/[^0-9.]/g, '') : '0';

export const isClosedApplication = (dueDate: Date, endDate: Date) => {
  const isBeforeEndDate = isBefore(new Date(dueDate), new Date(endDate));
  return isBeforeEndDate;
};
